/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/function-component-definition */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { DatePicker, Typography, message } from 'antd';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { GetMonthStatus } from '@common/utils/optionFilterHelper';

const { Text } = Typography;

function RangeMonthPicker({ options, onMonthChange }) {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [fromStatus, setFromStatus] = useState('');
  const [toStatus, setToStatus] = useState('');

  useEffect(() => {
    const now = dayjs().startOf('month');
    // ensure state always normalized to startOf month
    setFromDate(now);
    setToDate(now);

    const status = GetMonthStatus(options, now);
    setFromStatus(status);
    setToStatus(status);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  useEffect(() => {
    if (fromDate && toDate && typeof onMonthChange === 'function') {
      onMonthChange(fromDate, toDate);
    }
  }, [fromDate, toDate, onMonthChange]);

  // Disable future month
  const disabledFuture = useCallback((date) => {
    if (!date) return false;
    return dayjs(date).startOf('month').isAfter(dayjs().startOf('month'));
  }, []);

  const handleFromChange = useCallback(
    (val) => {
      if (!val) return;
      const normalized = dayjs(val).startOf('month');
      if (toDate && normalized.isAfter(toDate, 'month')) {
        message.error('開始年月が終了年月より先の年月になっています。');
        return;
      }
      setFromDate(normalized);
      const status = GetMonthStatus(options, normalized);
      setFromStatus(status);
    },
    [options, toDate],
  );

  const handleToChange = useCallback(
    (val) => {
      if (!val) return;
      const normalized = dayjs(val).startOf('month');
      if (fromDate && normalized.isBefore(fromDate, 'month')) {
        message.error('開始年月が終了年月より先の年月になっています。');
        return;
      }
      setToDate(normalized);
      const status = GetMonthStatus(options, normalized);
      setToStatus(status);
    },
    [options, fromDate],
  );

  const fromStatusEl = useMemo(
    () =>
      fromStatus ? <Text type="secondary">{`(${fromStatus})`}</Text> : null,
    [fromStatus],
  );
  const toStatusEl = useMemo(
    () => (toStatus ? <Text type="secondary">{`(${toStatus})`}</Text> : null),
    [toStatus],
  );

  return (
    <div className="display-flex item-center gap-8px">
      {/* FROM */}
      <div className="display-flex item-center gap-8px">
        <DatePicker
          picker="month"
          format="YYYY/MM"
          disabledDate={disabledFuture}
          value={fromDate}
          allowClear={false}
          placeholder="開始年月"
          className="jc-datepicker"
          popupClassName="jc-datepicker-popup"
          onChange={handleFromChange}
        />
        {fromStatusEl}
      </div>

      <p>~</p>

      {/* TO */}
      <div className="display-flex item-center gap-8px">
        <DatePicker
          picker="month"
          format="YYYY/MM"
          disabledDate={disabledFuture}
          value={toDate}
          allowClear={false}
          placeholder="終了年月"
          className="jc-datepicker"
          popupClassName="jc-datepicker-popup"
          onChange={handleToChange}
        />
        {toStatusEl}
      </div>
    </div>
  );
}

RangeMonthPicker.propTypes = {
  options: PropTypes.array,
  onMonthChange: PropTypes.func,
};

RangeMonthPicker.defaultProps = {
  options: [],
  onMonthChange: null,
};

export default RangeMonthPicker;
